import { castDraft } from 'immer';
import React, { createContext, PropsWithChildren, useMemo, useReducer } from 'react';
import { DispatchState } from 'shared/hooks/useDispatchState';

import { SaleDispatchObject } from '../store/actions';
import { initialState, saleContextReducer, SaleState } from '../store/reducer';

export type SaleDispatch<T = any> = React.Dispatch<SaleDispatchObject<T>>;

export type SaleContextType = DispatchState<SaleState, SaleDispatch>;

export const SaleContext = createContext({} as SaleContextType);

type SaleProviderProps = PropsWithChildren<{
  extraState?: Partial<SaleState>;
  testDispatch?: SaleDispatch;
}>;

export const SaleProvider: React.FC<SaleProviderProps> = ({ children, extraState = {}, testDispatch }: SaleProviderProps) => {
  const [state, dispatch] = useReducer(saleContextReducer, { ...initialState, ...extraState });

  const value = useMemo(() => {
    return { dispatch: testDispatch || dispatch, state: castDraft(state) };
  }, [dispatch, state]);

  return <SaleContext.Provider value={value}>{children}</SaleContext.Provider>;
};
